import React from 'react';
import WorkOrderTable from '../WorkOrderTable';
import { BUYER_WO_FILTERS_ORDER } from '../../utils/WorkOrderUtils';

export default function WorkOrdersArchivedIndexPage() {
	return (
		<WorkOrderTable
			handleQueryParams
			preAppliedFilters={{ hasBuyerArchived: true }}
			filterConfig={{
				filters: BUYER_WO_FILTERS_ORDER,
			}}
			targetCollectionName="archivedWorkOrdersIndex"
		/>
	);
}
